import React from "react";
import Marquee from "react-fast-marquee";

import { partnersMarqueeData } from "../model/constants";

export const PartnersMarquee: React.FC = () => {
  return (
    <Marquee
      style={{
        background: "transparent",
        padding: "12px 0",
        flexShrink: 0,
        overflowY: "hidden",
        maxHeight: "90px",
      }}
      gradient
      gradientColor="#fafafa"
      pauseOnHover
    >
      {partnersMarqueeData.map((data) => {
        return (
          <img
            key={data.alt}
            src={data.image}
            alt={data.alt}
            height={50}
            style={{
              objectFit: "contain",
              mixBlendMode: "multiply",
              margin: "0 32px",
              maxHeight: "50px",
            }}
          />
        );
      })}
    </Marquee>
  );
};
